import bankStyles from '../../assets/css/banks.module.css';
import useCustomization from '../../hooks/useCustomization';
import TextCustomization from '../customizations/TextCustomization';
import { CustomizationKey } from '../../contexts/CustomizationsContext';

const BANK_SELECTION_PAGE_TITLE_KEY: CustomizationKey = 'BANK_SELECTION_PAGE_TITLE';

const BankSelectionTitle = () => {
	const title = useCustomization(BANK_SELECTION_PAGE_TITLE_KEY);

	return (
		<div className={bankStyles['bank-selection-header']}>
			<h1
				className={bankStyles['banks-selection-title']}
				arial-level="1"
				aria-label="bank selection title"
				role="heading"
			>
				<TextCustomization content={title} />
			</h1>
		</div>
	);
};

export default BankSelectionTitle;
